import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAccountHeadquartersMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountHeadquartersInput;
}>;

export type UpdateAccountHeadquartersMutationResult = { __typename?: 'Mutation' } & {
  updateAccountHeadquarters?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountHeadquartersPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountHeadquartersDocument = gql`
  mutation updateAccountHeadquarters($input: UpdateAccountHeadquartersInput!) {
    updateAccountHeadquarters(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
